import React from 'react';
import {LANGUAGE_MENU} from "../../../../../modules/language-menu-module/language-menu-module.consts";
import styles from "../styles/footer.module.scss";
import classNames from "classnames";
import {LanguageMenuModuleAsync} from "../../../../../modules/language-menu-module/components/language-menu.module.async";

export const FooterModuleLangPicker = ({shouldRenderLangMenu}) => {
  return (
    <div className={classNames(styles.lang_container)}>
      {
        shouldRenderLangMenu ? <LanguageMenuModuleAsync type={LANGUAGE_MENU.MENU_TYPE.expand}/> : null
      }
    </div>
  );
}
